// extracted by mini-css-extract-plugin
export default {"container":"Header_Body_container__1HJyt","title_container":"Header_Body_title_container__+c7kJ","body_container":"Header_Body_body_container__A4nHx"};